<template>
  <div class="machinery-manufactur">
    <s-r-m-header ref="header" />
    <IndustryDesc ref="industryDesc" :industryInfo="industryInfo" />
    <ProjectDesc
      :descInfo="{
        title: '工业制造行业业务特征',
        description: '璞华易研PLM提供适用于机械制造行业的研发管理解决方案',
        redContent: '工业设备等制造业',
        content: '的分工合作越来越细，而部门的相对独立以及客户化定制要求，导致产品研发周期长且协同较少，研发部门到生产部门往往只有纸质文件传递，这对企业的设计生产方式、管理模式提出了严峻挑战。企业实施PLM系统可以使产品开发管理更加精细化，通过细化项目管理颗粒度，打破研发过程中部门之间的壁垒，从而实现研发、工艺、制造计划的协同分工与统筹安排。璞华易研PLM能帮助企业在研发管理方面极大提升工作效率，实现上游技术部门和下游生产制造部门之间信息及时传递。'
      }"
    ></ProjectDesc>
    <ProblemSolving
      :textList="textList"
    ></ProblemSolving>
    <AppBenefits></AppBenefits>
    <!-- <product-features
      title="产品功能"
      description="PLM产品生命周期管理产品数据管理、项目协同管理、研发管理、设计工具集成"
      :tabList="tabList"
    ></product-features> -->
    <CompanyInfo
      :projectInfo="projectInfo"
    ></CompanyInfo>

    <ResultsOperation
      :descInfo="{
        title: '运营效果',
        descArr1: [
          '建立统一的公司级产品数据管理平台',
          '降本增效、较少数据冗余',
          '通过系统完整记录产品的研发过程、变更记录及版本控制',
          '规范并固化设计变更管理流程，实现对所有技术数据变更的可追溯',
        ]
      }"
    ></ResultsOperation>

    <ChooseUs :nameVals="['EquipmentManufacturing']"></ChooseUs>
    <custom-form ref="customForm" />
    <footer-box /> 
  </div>
</template>

<script>
import SRMHeader from "@/components/SRMHeader/index";
import IndustryDesc from "@/components/IndustryDesc"
import ProblemSolving from "@/components/ProblemSolving"
import ProjectDesc from "@/components/ProjectDesc"
import AppBenefits from "@/components/AppBenefits"
import ProductFeatures from "@/components/ProductFeatures"
import CompanyInfo from "@/components/CompanyInfo"
import ResultsOperation from "@/components/ResultsOperation"
import ChooseUs from "@/components/ChooseUs"
import CustomForm from "@/components/Form"
import FooterBox from "@/components/FooterBox"
import { baiduConsult } from "./common.js";

import hy3 from '@/assets/images/hy3.png'

export default {
  components: {
    SRMHeader,
    IndustryDesc,
    ProblemSolving,
    ProjectDesc,
    AppBenefits,
    ProductFeatures,
    CompanyInfo,
    ResultsOperation,
    ChooseUs,
    CustomForm,
    FooterBox,
  },
  metaInfo() {
    return {
      title: '璞华易研 - 企业级PLM&PMS解决方案',
      meta: [
        {
          name: 'keywords',
          content: '璞华易研,PLM,PMS,PDM,产品生命周期管理,研发项目管理,国产PLM,智能制造'
        },
        {
          name: 'description',
          content: '璞华官方热线：4006-160-730。璞华易研PLM&PMS，帮助客户高效实现产品生命周期管理和研发项目管理，在流程行业、医疗器械、芯片半导体、电子高科技、机械制造等方面拥有丰富的案例。'
        }
      ]
    }
  },
  data() {
    return {
      textList: [
        {
          name: '变更设计',
          list: [
            '评估难',
            '更新烦',
            'ECN慢',
          ],
        },
        {},
        {
          name: '流程管理',
          list: [
          '业务流转效率低',
          '流程难监控',
          '流程不执行',
          '流程难优化',
          '流程难固化',
          '管理体系难于落实'
          ],
        },
        {
          name: '项目管理',
          list: [
          '项目进度监控',
          '项目任务分派',
          '工程师工作负荷',
          '人员的业绩考核',
          '项目过程文档收集'
          ],
        },
        {
          name: '物料管理',
          list: [
            '产品品类多',
            'BOM管理困难',
            '零部件借用少',
            '零部件标准化低',
            '随意创建零件',
            '新零件的认证'
          ],
        },
        {
          name: '文档管理',
          list: [
            '资料存放混乱',
            '版本不一致',
            '信息的共享差',
            '查找图纸困难',
            '产品的资料完整性',
            '文档管理权限差',
            '文控规范难落实'
          ],
        },
        {
          name: '系统集成',
          list: [
            '与CAD集成',
            '与ERP集成',
            '与OA集成',
          ],
        }
      ],
      listData: [
        {
          num: '01',
          description: '建立符合医疗设备行业QMS体系的合规数据集（含DHF、DMR、R/A docs、Risk Management、Change Managemgmt 、CAPA',
        },
        {
          num: '02',
          description: '建立符合医疗设备行业QMS体系的产品开发项目管理体系，对设备研发过程、资源、交付物及过程质量进行管理',
        },
        {
          num: '03',
          description: '建立协同的技术评审及产品资料电子化审签流程，对资料的创建、审批及发布进行管理',
        },
        {
          num: '04',
          description: '建立产品全过程闭环质量管理体系，对研发过程质量、缺陷、生产过程质量、客户投诉等进行统一管理',
        }
      ],
      industryInfo: {
        bg: hy3,
        text2: '璞华易研PLM系统可以帮助工业制造企业在产品设计、开发、制造和服务',
        text3: '等全生命周期阶段进行有效管理和协同'
      },
      projectInfo: {
        companyName: '昆山艾派科技有限公司',
        description: '一家专注于轻量型高端工业机器人及控制系统核心技术开发的高新技术企业，拥有实力强劲的研发技术团队，掌握 机器人控制、驱动、传动 等核心技术',
        paragraph: [
          '市场竞争激烈，客户需求增加，同时随着公司规模的不断扩大，设计研发人员的增多，产品种类也越来越丰富，现阶段这种传统的以部门为管理机构，以部门组织机构为管理核心的组织管理方式越来越显的力不从心，突出体现在对公司产品图纸管理上已经严重出现滞后，不仅影响设计人员的工作效率，而且容易造成产品质量的下滑，无法实现业务协同，信息处于孤岛，无法形成闭环管理模式，无法从本质上实现企业利益增长。'
        ],
        caseList: [
          {
            num: '01',
            title: '文档管理',
            contentList: [
              '资料查询效率提高十倍以上',
              '企业统一数据版本，版本出错减少80％',
              '提高数据重用率，降低重复工作',
              '资料流转效率提升五倍以上',
              '符合ISO标准的文档管理规范、资料管理井井有条',
              '建立企业知识管理库和标准文档库，实现知识的共享与传承'
            ]
          },
          {
            num: '02',
            title: '数据管理',
            contentList: [
              '建立企业物料标准库，规范管理物料。',
              '设计引用和重用，有强力系统保证',
              '各种设计信息关联管理，便于使用',
              '实现高效率的产品协同设计'
            ]
          },
          {
            num: '03',
            title: '项目管理',
            contentList: [
              '体现IPD理念的项目全过程规划（项目分解、人员分工、工期、项目输出、决策流程控制）',
              '任务自动分派，集中提醒跟踪，预警 及管理',
              '项目统计快速汇总，更好地跟踪管控（项目甘特图、项目进度、人员负荷）',
              '固化开发流程，控制关键节点必须执行'
            ]
          }
        ]
      },
      tabList: [
        {
          name: 'first',
          label: '数据管理',
          title: '以数据为核心',
          otherTitle: '将数据管理贯穿产品的全生命周期',
          effectDrawing: require('@/assets/images/gn1.png'),
          contentList: [
            {
              title: '物料管理',
              content: '物料编码规则、物料属性定义、物料的生命周期管理、物料分类定义'
            },
            {
              title: 'bom管理',
              content: 'bom结构、替代料管理、bom正反结构查询'
            },
            {
              title: '制造商管理',
              content: '制造商管理、制造商部件号管理'
            },
            {
              title: '文档管理',
              content: '文档分类、文档版本、文档权限等管理'
            }
          ]
        },
        {
          name: 'second',
          label: '变更管理',
          title: '根据用户的个性化需求，支持用户定义各种规则，对变更进行',
          otherTitle: '跟踪和管理',
          effectDrawing: require('@/assets/images/gn2.png'),
          contentList: [
            {
              content: '内置了行业标准的ECR-ECO的工程变更解决方案'
            },
            {
              content: '可以根据客户的个性化需求进行业务流程配置'
            },
            {
              content: '提供了行业领先的用户可编程引擎，支持用户定义各种规则'
            }
          ]
        },
        {
          name: 'third',
          label: '项目管理',
          title: '项目计划＆项目进度＆项目交付＆项目报表',
          effectDrawing: require('@/assets/images/gn3.png'),
          contentList: [
            {
              content: '采用最新的BS技术实现项目中的各种管理功能'
            },
            {
              content: '包含项目计划、交付、资源、工时、费用、报表等核心功能'
            },
            {
              content: '帮助企业实现项目集的管理，规范项目数据，缩短研发周期'
            }
          ]
        },
        {
          name: 'four',
          label: '数据建模',
          title: '通过数据建模，支持客户的个性化需求',
          effectDrawing: require('@/assets/images/gn4.png'),
          contentList: [
            {
              content: '提供强大的配置平台，支持根据客户的个性化需求配置基础设置、对象分类、对象属性、工作流程、权限'
            },
            {
              content: '实现完全可配置的业务，支持数据、流程、字段级别的数据建模和精细化的权限控制'
            }
          ]
        },
        {
          name: 'five',
          label: '在线可视化',
          title: '目前支持超过40多种主流的文件格式在线预览，所见即所得',
          effectDrawing: require('@/assets/images/gn5.png'),
          contentList: [
            {
              content: '采用最新的BS架构实现了文件的预览，不需要用户客户端安装任何的客户端软件'
            },
            {
              content: '支持主流2D文件(Office、CAD、压缩文件、文本文件、图片、音频)格式的预览'
            },
            {
              content: '支持主流3D文件(prt、asm、pcb、stp) 格式的预览'
            }
          ]
        },
        {
          name: 'six',
          label: '第三方接入',
          title: '轻松实现与第三方软件的对接',
          effectDrawing: require('@/assets/images/gn6.png'),
          contentList: [
            {
              content: '通过标准的API接口和Webservice接口，实现PLM的数据同企业的其他业务系统和移动办公系统的深度集成'
            },
            {
              content: '自带主流的ERP集成接口和移动端集成，支持数据导出'
            }
          ]

        }
      ]
    }
  },
  mounted() {
    baiduConsult();
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/mixins.scss";

.machinery-manufactur {
  ::v-deep .project-desc {
    .project-content {
      width: 140rem;
    }
  }
  ::v-deep .industry-desc {
    .text-content {
      padding-top: 16.8rem;
      .text2,.text3 {
        line-height: 7.2rem;
      }
    }
  }
  ::v-deep .systemFunction-container {
    background: linear-gradient( 168deg, #FBFCFD 0%, #F4F7F9 100%);
  }
  ::v-deep .point-of-pain {
    .point-of-pain-title {
      padding: 10rem 0 2.4rem !important;
    }
    .point-of-pain-description {
      padding-bottom: 6.2rem !important;
    }
    .list-item {
      padding: 5.6rem 5.2rem 0rem 4.8rem !important;
      height: 24.6rem !important;
      .cl-list {
        margin-top: 3rem !important;
      }
      .cl-l-i-content {
        padding-left: 0 !important;
        &::before {
          border: none !important;
        }
      }
    }
  }
  .typical-user {
    ::v-deep .systemFunction-list {
      height: 55.2rem;
    }
  }
  ::v-deep .productfeature {
    .content-left {
      padding: 0;
      left: 26rem;
      width: 54rem;
    }
    .content-right {
      width: 88.2rem;
      height: 51rem;
      top: 12.7rem;
      right: 17.1rem;
    }
  }

  @include mobile-page-overrides;
}
</style>
